import {
  Component,
  Inject,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ConfirmDialogComponent, ConfirmDialogData } from "@cotecna/dialogs";
import { Inspector } from "src/app/settings/models/inspector";
import { InspectorsTeamOverview } from "src/app/settings/models/inspector-team-overview";
import { InspectorsTeamsService } from "src/app/settings/services/inspectors-teams.service";
@Component({
    selector: "im-edit-inspector-teams",
    templateUrl: "./edit-inspector-teams.component.html",
    styleUrls: ["./edit-inspector-teams.component.scss"],
    standalone: false
})
export class EditInspectorTeamsComponent implements OnInit {
  @ViewChild("membersScroll") private myScrollContainer: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<EditInspectorTeamsComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    private inspectorsTeamService: InspectorsTeamsService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
  ) {}
  public validateUserFlag: boolean = false;

  inspectorsTeam: InspectorsTeamOverview = {
    name: "",
    members: [],
  } as InspectorsTeamOverview;

  inspectors: Inspector[];

  controls: UntypedFormControl[] = [];

  ngOnInit(): void {
    if (this.dialogData) {
      this.inspectorsTeam.id = this.dialogData.inspectorsTeam.id;
      this.inspectorsTeam.name = this.dialogData.inspectorsTeam.name;
      this.inspectorsTeam.members = this.dialogData.inspectorsTeam.members;
      this.inspectorsTeam.members.forEach((element, index) => {
        this.controls.push(new UntypedFormControl());
        this.controls[index].setValue(element);
      });
    }
  }

  async onInputChanged(search: string) {
    if (search.length === 0) {
      this.validateUserFlag = false;
    } else {
      this.inspectors = await this.inspectorsTeamService.getInspectors(search);
    }
  }

  getTitle(): string {
    return this.dialogData ? "Edit Team" : "Create New Team";
  }

  displayFn(inspector) {
    return inspector?.name ?? "";
  }

  onInspectorSelected(inspector, index) {
    this.validateInspectorMessage(inspector);
    if (this.validateUserFlag) {
      return;
    }
    if (
      !this.inspectorsTeam.members
        .filter((m) => this.inspectorsTeam.members.indexOf(m) != index)
        .find((m) => m.userId == inspector.userId)
    ) {
      this.inspectorsTeam.members[index].name = inspector.name;
      this.inspectorsTeam.members[index].userId = inspector.userId;
    } else {
      this.inspectorsTeam.members[index].name = "";
      this.inspectorsTeam.members[index].userId = "";
    }
  }

  isFormReady(): boolean {
    let resultValue =
      this.inspectorsTeam.name &&
      this.inspectorsTeam.members?.length > 0 &&
      this.inspectorsTeam.members?.every((m) => m.userId != "");
    if (!this.validateUserFlag) {
      resultValue = true;
    }
    return resultValue;
  }

  addAdditionalMember(): void {
    const member = { name: "", userId: "" } as Inspector;
    this.inspectorsTeam.members.push(member);
    this.controls.push(new UntypedFormControl());
    this.scrollToBottom();
  }

  allTeamMembersAreCorrect(): boolean {
    if (!this.inspectorsTeam?.members?.length) return true;
    if (this.inspectorsTeam.members?.every((m) => m.userId != "")) return true;
    if (!this.validateUserFlag) return true;
    return false;
  }

  cancel(): void {
    this.dialogRef.close({ result: false, inspectorsTeam: {} });
  }

  async save() {
    const alreadyExists = await this.inspectorsTeamService.inspectorsTeamExists(
      this.inspectorsTeam.name,
      this.inspectorsTeam.id,
    );
    if (alreadyExists) this.openAlreadyExistsDialog();
    else {
      this.controls
        .filter((members) => members.value !== null)
        .forEach((obj) => {
          if (
            this.inspectorsTeam.members.filter(
              (user) => user.userId == obj.value.userId,
            ).length === 0
          ) {
            this.inspectorsTeam.members.push(obj.value);
          }
        });
      this.dialogRef.close({
        result: true,
        inspectorsTeam: this.inspectorsTeam,
      });
    }
  }

  removeInspector(inspector: Inspector, index) {
    this.controls.splice(index, 1);
    this.inspectorsTeam.members = this.inspectorsTeam.members.filter(
      (m) => m.userId !== inspector.userId,
    );
    this.inspectors = [];
    this.cdr.detectChanges();
    this.validateInspectorMessage(inspector);
  }

  scrollToBottom(): void {
    try {
      this.cdr.detectChanges();
      this.myScrollContainer.nativeElement.scrollTop =
        this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) {}
  }

  private openAlreadyExistsDialog() {
    this.dialog.open(ConfirmDialogComponent, {
      autoFocus: false,
      data: <ConfirmDialogData>{
        icon: "warning",
        okButton: {
          text: "ACCEPT",
          color: "primary",
        },
        cancelButton: {
          text: "",
        },
        title: "Inspectors team already exists",
        message: `The name ${this.inspectorsTeam.name} already exists for another inspector team.`,
      },
    });
  }

  private validateInspectorMessage(inspector: Inspector) {
    if (
      this.inspectorsTeam.members.find(
        (member) => member.userId === inspector.userId,
      )
    ) {
      this.validateUserFlag = true;
    } else {
      this.validateUserFlag = false;
      this.inspectorsTeam.members = this.inspectorsTeam.members.filter(
        (m) => m.userId !== inspector.userId,
      );
    }
  }
}
